module.exports = __webpack_public_path__ + "35419e354261638f1c8ca2f3ec069c90.woff";